import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import Typed from 'typed.js';
import { Box, Button } from '@miro-site/core';
import { LazyImageAdapter } from '@miro-site/components_utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs({
  $pt: [40, 77],
  $pb: [40, 60],
  $px: [20, 40],
  $styles: {
    maxWidth: [null, null, 1200]
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__Container",
  componentId: "sc-u8ro5g-0"
})(["position:relative;box-sizing:border-box;margin:0 auto;"]);
export var Title = styled.h1.withConfig({
  displayName: "HeroWithTypingAnimation__Title",
  componentId: "sc-u8ro5g-1"
})(["font-family:", ";font-feature-settings:'zero' on,'ss02' on,'ss06' on,'ss05' on;font-weight:bold;text-align:center;position:relative;", ";.typed-cursor{opacity:1;position:relative;display:inline-block;background:#9d28b2;width:1px;height:1em;margin-left:0.1em;margin-bottom:-0.12em;}.typed-cursor.typed-cursor--blink{animation:typedjsBlink 0.7s infinite;}@keyframes typedjsBlink{50%{background:transparent;}}.typed-cursor:after{content:'';display:block;position:absolute;top:-1.05em;left:0;width:1.4em;height:1.03em;background:url('https://static-website.miro.com/static/images/page/mr-index/localization/en/pointer.svg') 0 0 no-repeat;background-size:contain;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.spoof;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    fontSize: [40, 64],
    lineHeight: [44, 68],
    letterSpacing: [-0.5, -1],
    marginBottom: [16, 24],
    marginLeft: [-4, 'auto'],
    marginRight: [-4, 'auto']
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return css(["", ""], theme.mq.small(css([".typed-cursor{background:", ";}.typed-cursor:after{display:none;}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.primaryIndigo;
  })));
});
var Break = styled(Box).attrs({
  as: 'br',
  $styles: {
    display: ['none', null]
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__Break",
  componentId: "sc-u8ro5g-2"
})([""]); // Mobile Only

var BreakMO = styled(Box).attrs({
  as: 'br',
  $styles: {
    display: [null, 'none']
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__BreakMO",
  componentId: "sc-u8ro5g-3"
})([""]);
var Description = styled(Box).attrs({
  $mb: [24, 40],
  $styles: {
    fontSize: [18],
    lineHeight: [24]
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__Description",
  componentId: "sc-u8ro5g-4"
})(["position:relative;text-align:center;"]);
var SubTitle = styled(Box).attrs({
  $styles: {
    fontSize: [14],
    lineHeight: [20],
    marginTop: [16]
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__SubTitle",
  componentId: "sc-u8ro5g-5"
})(["color:", ";text-align:center;opacity:0.4;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primaryIndigo;
});
var Banners = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: [40, 67],
    left: [40, 90]
  }
}).withConfig({
  displayName: "HeroWithTypingAnimation__Banners",
  componentId: "sc-u8ro5g-6"
})(["img{", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.normalizeStyles({
    height: [213, 326]
  });
});
var ButtonWrapper = styled.div.withConfig({
  displayName: "HeroWithTypingAnimation__ButtonWrapper",
  componentId: "sc-u8ro5g-7"
})(["text-align:center;position:relative;"]);

var HeroWithTypingAnimation = function HeroWithTypingAnimation() {
  // DOM element containing the typing animation
  var el = React.useRef(null); // Typed.js instance

  var typed = React.useRef(null);
  useEffect(function () {
    var options = {
      strings: ['distributed', 'remote', 'work from home', 'telecommuting', 'hybrid'],
      typeSpeed: 70,
      startDelay: 0,
      backSpeed: 60,
      backDelay: 1400,
      loop: true,
      showCursor: true,
      cursorChar: '',
      autoInsertCss: false
    }; // el refers to the <span> rendered below

    if (el.current) typed.current = new Typed(el.current, options);
    return function () {
      var _typed$current;

      // preventing memory leaks
      (_typed$current = typed.current) === null || _typed$current === void 0 ? void 0 : _typed$current.destroy();
    };
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Banners, {
      children: /*#__PURE__*/_jsx(LazyImageAdapter, {
        assets: {
          desktop: {
            src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/banner-desktop.png?v=0003',
            alt: 'Miro'
          },
          mobile: {
            src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/hero-banner-mobile.png?v=0003',
            alt: 'Miro'
          }
        }
      })
    }), /*#__PURE__*/_jsxs(Title, {
      children: ["Where ", /*#__PURE__*/_jsx(BreakMO, {}), " ", /*#__PURE__*/_jsx("span", {
        ref: el
      }), " ", /*#__PURE__*/_jsx(Break, {}), /*#__PURE__*/_jsx(BreakMO, {}), "teams get", /*#__PURE__*/_jsx(BreakMO, {}), " work done"]
    }), /*#__PURE__*/_jsxs(Description, {
      children: ["The online collaborative ", /*#__PURE__*/_jsx(BreakMO, {}), " whiteboard platform to", /*#__PURE__*/_jsx(Break, {}), "bring ", /*#__PURE__*/_jsx(BreakMO, {}), " teams together, anytime, anywhere.", /*#__PURE__*/_jsx(Break, {})]
    }), /*#__PURE__*/_jsx(ButtonWrapper, {
      children: /*#__PURE__*/_jsx(Button, {
        href: "/app",
        $buttonType: "primary",
        $size: "medium",
        $withArrow: true,
        children: "Start a whiteboard"
      })
    }), /*#__PURE__*/_jsx(SubTitle, {
      children: "Free forever \u2014 no credit card required"
    })]
  });
};

export default HeroWithTypingAnimation;